import { render, staticRenderFns } from "./wuliuList.vue?vue&type=template&id=c0e742a6&scoped=true"
import script from "./wuliuList.vue?vue&type=script&lang=js"
export * from "./wuliuList.vue?vue&type=script&lang=js"
import style0 from "./wuliuList.vue?vue&type=style&index=0&id=c0e742a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e742a6",
  null
  
)

export default component.exports